<template>
  <div>
    <div class="zg-quote">
      <p>{{ text }}</p>

      <div class="zg-quote__arrow">
        <zg-icon
          icon="tooltip-arrow"
          color="beige"
        />
      </div>
    </div>

    <p><b>{{ name }}</b></p>
  </div>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'
  export default {
    name: 'ZgInlineQuote',
    components: {
      ZgIcon
    },
    props: {
      name: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
.zg-quote {
  position: relative;
  max-width: max-content;
  background-color: color(beige);
  border-radius: radius(large);
  padding: rhythm(small);
  margin-bottom: rhythm(small);

  p {
    margin-bottom: 0;
  }

  &__arrow {
    position: absolute;
    left: 3rem;
    top: calc(100% - #{rhythm(xsmall)});
    transform: scaleX(-1);
  }
}
</style>
